import { formatMoney, formatMoneyFull, currencyDisplay, toNumber } from '@/lib/money'

export function formatRevenueFull(value: string | number, currency?: string | null): string {
  return formatMoneyFull(value, currency)
}

// Symbol-less compact for dense grid cells. K/M/B tiers only (historical).
export function formatRevenueCompact(value: string | number, currency?: string | null): string {
  const n = toNumber(value)
  if (!Number.isFinite(n)) return String(value)
  if (n === 0) return '0'
  const abs = Math.abs(n)
  if (abs >= 1_000_000_000) return `${trim(n / 1_000_000_000)}B`
  if (abs >= 1_000_000) return `${trim(n / 1_000_000)}M`
  if (abs >= 1_000) return `${trim(n / 1_000)}K`
  const { decimals } = currencyDisplay(currency)
  return decimals > 0 ? n.toFixed(decimals) : `${n}`
}

function trim(n: number): string {
  return n.toFixed(1).replace(/\.0$/, '')
}

export function formatVND(value: string | number, currency?: string | null): string {
  return formatMoney(value, currency)
}

export function formatPct(share: number): string {
  const pct = share * 100
  if (pct > 0 && pct < 0.1) return '<0.1%'
  return `${pct.toFixed(1)}%`
}
